/* A&Y — thermomètre des cadeaux : mise à jour en direct (tiroir panier, accueil, page panier).
   v5 : dans le tiroir, la barre de livraison et le thermomètre passent SOUS les articles ; la barre de livraison
   ne s'affiche que lorsqu'il manque 20 $ ou moins (seuil Québec 75 $, Canada 100 $).
   v8 : le cadeau se choisit avec photos directement dans le tiroir (ay-gifts.js) : le bouton principal mène
   donc directement à la caisse, sauf si un ZEM Sack est au panier (vérification sur la page panier). */
(() => {
  'use strict';
  const en = document.documentElement.lang.startsWith('en');
  const MAX = 20000;
  const SHIP_QC = 7500;
  const SHIP_CA = 10000;
  const SHIP_SHOW_WITHIN = 2000;
  const ZEM_SACK_ID = 10227283460288;
  const TIERS = en
    ? [[5000, '1 MINUS gift'], [10000, '2 MINUS gifts'], [15000, '1 Tout Doux + 1 MINUS'], [20000, 'the 3-month VIP pass']]
    : [[5000, '1 cadeau MINUS'], [10000, '2 cadeaux MINUS'], [15000, '1 Tout Doux + 1 MINUS'], [20000, 'le pass VIP 3 mois']];
  const money = cents => (window.ayMoney ? window.ayMoney(cents) : new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency: 'CAD' }).format(cents / 100));
  const short = cents => (en ? '$' + (cents / 100) : (cents / 100) + ' $');
  const strings = (() => { try { return JSON.parse(document.getElementById('ay-strings')?.textContent || '{}'); } catch (_) { return {}; } })();
  const t = (key, vars = {}) => Object.keys(vars).reduce((out, k) => out.split('{' + k + '}').join(vars[k]), String(strings[key] || key));
  const text = {
    unlocked: en ? 'Unlocked' : 'Débloqué',
    add: en ? 'Add ' : 'Encore ',
    next: (amount, label) => (en ? `Add ${amount} to unlock ${label}` : `Encore ${amount} pour débloquer ${label}`),
    all: en ? 'All gift tiers unlocked.' : 'Tous les paliers cadeaux sont débloqués.',
    track: en ? 'Progress towards the gift tiers' : 'Progression vers les paliers cadeaux'
  };
  function update(root, cents) {
    cents = Math.max(0, Number(cents) || 0);
    root.dataset.total = String(cents);
    const fill = root.querySelector('[data-ay-meter-fill]');
    if (fill) fill.style.width = Math.min(100, (cents / MAX) * 100) + '%';
    root.querySelectorAll('[data-ay-meter-mark]').forEach(mark => mark.classList.toggle('is-on', cents >= Number(mark.dataset.ayMeterMark)));
    let next = null;
    root.querySelectorAll('[data-tier]').forEach(li => {
      const tier = Number(li.dataset.tier);
      const remaining = tier - cents;
      const unlocked = remaining <= 0;
      li.classList.toggle('is-unlocked', unlocked);
      const out = li.querySelector('[data-ay-meter-remaining]');
      if (out) out.textContent = unlocked ? text.unlocked : text.add + money(remaining);
      if (!unlocked && !next) next = { remaining, label: li.dataset.label || '' };
    });
    const status = root.querySelector('[data-ay-meter-status]');
    if (status) status.textContent = next ? text.next(money(next.remaining), next.label) : text.all;
    if (root.hasAttribute('data-ay-meter-hide-empty')) root.hidden = cents <= 0;
  }
  /* Tiroir panier : le thermomètre (version courte) est construit ici, sous les articles. */
  function buildCompact() {
    const drawer = document.getElementById('AYCartDrawer');
    if (!drawer || drawer.querySelector('[data-ay-gift-meter]')) return;
    const items = drawer.querySelector('[data-ay-cart-items]');
    if (!items) return;
    const root = document.createElement('div');
    root.className = 'ay-meter ay-meter--compact';
    root.setAttribute('data-ay-gift-meter', '');
    root.setAttribute('data-ay-meter-hide-empty', '');
    root.hidden = true;
    root.dataset.total = '0';
    const marks = TIERS.map(([amount], i) => `<span class="ay-meter__mark" data-ay-meter-mark="${amount}" style="left: ${(i + 1) * 25}%;"><b>${short(amount)}</b></span>`).join('');
    const tiers = TIERS.map(([amount, label]) => `<li data-tier="${amount}" data-label="${label}"><span class="ay-meter__check" aria-hidden="true">✓</span><span class="ay-meter__label"><b>${short(amount)}</b> · ${label}</span><em data-ay-meter-remaining></em></li>`).join('');
    root.innerHTML = `<p class="ay-meter__status" data-ay-meter-status aria-live="polite"></p><div class="ay-meter__track" role="img" aria-label="${text.track}"><div class="ay-meter__fill" data-ay-meter-fill style="width: 0%;"></div>${marks}</div><ul class="ay-meter__tiers">${tiers}</ul>`;
    const shipping = drawer.querySelector('[data-ay-shipping]');
    (shipping && shipping.previousElementSibling === items ? shipping : items).insertAdjacentElement('afterend', root);
  }
  /* Tiroir panier : barre de livraison sous les articles, seuil 75 $ (QC) / 100 $ (CA), visible seulement quand on est proche. */
  function tuneDrawer(cart) {
    const drawer = document.getElementById('AYCartDrawer');
    if (!drawer) return;
    const items = drawer.querySelector('[data-ay-cart-items]');
    const shipping = drawer.querySelector('[data-ay-shipping]');
    const meter = drawer.querySelector('[data-ay-gift-meter]');
    if (items && shipping && shipping.previousElementSibling !== items) items.insertAdjacentElement('afterend', shipping);
    if (meter && shipping && meter.previousElementSibling !== shipping) shipping.insertAdjacentElement('afterend', meter);
    const total = Math.max(0, Number(cart?.total_price) || 0);
    const hasZem = Array.isArray(cart?.items) && cart.items.some(item => Number(item.product_id) === ZEM_SACK_ID);
    if (shipping && !shipping.hidden) {
      const remaining = Math.max(0, SHIP_QC - total), remainingCanada = Math.max(0, SHIP_CA - total);
      const progress = shipping.querySelector('progress');
      if (progress) { progress.max = SHIP_CA; progress.value = Math.min(SHIP_CA, total); }
      const message = shipping.querySelector('[data-ay-shipping-message]');
      if (message) message.textContent = remaining ? t('shippingRemaining', { amount: money(remaining) }) : remainingCanada ? t('shippingQuebec', { amount: money(remainingCanada) }) : t('shippingCanada');
      shipping.hidden = remaining > SHIP_SHOW_WITHIN;
    }
    if (meter) {
      const status = meter.querySelector('[data-ay-meter-status]');
      if (status) status.hidden = Boolean(shipping && !shipping.hidden && total < SHIP_QC);
    }
    const cta = drawer.querySelector('[data-ay-cart-cta]');
    if (cta) {
      const label = hasZem ? cta.dataset.labelReview : cta.dataset.labelCheckout;
      const href = hasZem ? cta.dataset.cartUrl : cta.dataset.checkoutUrl;
      if (cta.getAttribute('href') !== href) cta.setAttribute('href', href);
      const arrow = cta.querySelector('span');
      if (label && cta.firstChild && cta.firstChild.nodeType === 3) cta.firstChild.textContent = label + ' ';
      else if (label) { cta.textContent = label + ' '; if (arrow) cta.append(arrow); }
    }
  }
  const all = () => document.querySelectorAll('[data-ay-gift-meter]');
  const init = () => { buildCompact(); all().forEach(root => update(root, root.dataset.total)); };
  document.addEventListener('ay:cart:updated', event => {
    const cart = event.detail;
    if (!cart || typeof cart.total_price !== 'number') return;
    all().forEach(root => update(root, Math.max(0, (Number(cart.total_price) || 0) - (cart.items || []).reduce((s, i) => s + (String(i.vendor || '').toLowerCase().trim() === 'morpheïa' ? Number(i.final_line_price) || 0 : 0), 0))));
    tuneDrawer(cart);
  });
  document.addEventListener('shopify:section:load', init);
  init();
  window.ayGiftMeter = { update };
})();